export default function BrandServe() {
  return <div className="root">BrandServe</div>;
}
